export default {
    // Vai trò
    RoleType: 1,
    // Loại việc
    TaskType : 2,
    // Thời gian
    DateCombobox : 3,
    // Sắp xếp
    Sort : 4,
    // Nhắc việc
    NumberRemind : 5,
    // Chọn đơn vị
    SelectOrg : 7,
    // Chọn kỳ
    DatePeriod : 8
  };
